var _circle, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeletePopup(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25.0986,
    cy: 25.2168,
    r: 24.292,
    fill: "#FFE1E1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.3486 19.7998L30.8322 28.1541C30.7002 30.2885 30.6343 31.3557 30.0993 32.1231C29.8347 32.5024 29.4942 32.8226 29.0992 33.0631C28.3004 33.5498 27.2311 33.5498 25.0925 33.5498C22.9512 33.5498 21.8805 33.5498 21.0812 33.0622C20.686 32.8212 20.3453 32.5005 20.0809 32.1205C19.546 31.352 19.4815 30.2832 19.3525 28.1458L18.8486 19.7998",
    stroke: "#F80B0B",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5986 19.8005H32.5986M28.4784 19.8005L27.9095 18.6269C27.5316 17.8473 27.3426 17.4576 27.0167 17.2145C26.9445 17.1605 26.8679 17.1126 26.7878 17.071C26.4269 16.8838 25.9937 16.8838 25.1274 16.8838C24.2393 16.8838 23.7953 16.8838 23.4284 17.0789C23.347 17.1221 23.2694 17.172 23.1964 17.2281C22.8667 17.481 22.6825 17.8851 22.3141 18.6932L21.8094 19.8005",
    stroke: "#F80B0B",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0156 28.9668V23.9668",
    stroke: "#F80B0B",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1816 28.9668V23.9668",
    stroke: "#F80B0B",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeletePopup);
export default __webpack_public_path__ + "static/media/deletePopup.8d3f58222878bbe40cd28eb1f522dc7b.svg";
export { ForwardRef as ReactComponent };